import { call, put, fork, take } from 'redux-saga/effects'

import debugLib from 'debug'

import {
  fetchSpecialOffersFailure,
  fetchSpecialOffersSuccess
} from '../../actionCreators/specialOffers/specialOffersActionCreators'

import { FETCH_SPECIAL_OFFERS_REQUEST } from '../../actionTypes/specialOffersActionTypes'

import { fetchApi } from '../helpers/fetchApi'

import Logger from '../../helpers/Logger'

const logger = Logger.getInstance()
const debug = debugLib('SpecialOffersSaga')

const endpoint = '/product-api/special-offers-service/partNumber'

function* specialOffersSaga(action, baseUrl, cookies) {
  const {
    payload: { partNumber }
  } = action
  const start = Date.now()
  debug('Calling Special offers API with payload', partNumber)

  try {
    const url = `${baseUrl || ''}${endpoint}/${partNumber}`
    const headers = process.env.STUB_ENABLED === 'true' ? { Cookie: cookies } : {}
    const jsonData = yield call(fetchApi, url, null, headers)
    debug('Special offers API call complete')
    const responseTime = Date.now() - start
    logger.debug('specialOffersLogger', { partNumber, responseTime, jsonData }, 'specialOffers read')
    const successAction = fetchSpecialOffersSuccess({ offers: jsonData })
    yield put(successAction)
  } catch (error) {
    const responseTime = Date.now() - start
    logger.error('specialOffersLogger', { partNumber, responseTime, error }, 'specialOffersSaga error')
    const failureAction = fetchSpecialOffersFailure(error)
    yield put(failureAction)
  }
}

export { specialOffersSaga, endpoint }

// Watches for the 'FETCH_SPECIAL_OFFERS_REQUEST' action then fires the saga
export function* watchSpecialOffers(cookies) {
  while (true) {
    const { payload, baseUrl } = yield take(FETCH_SPECIAL_OFFERS_REQUEST)
    yield fork(specialOffersSaga, { payload }, baseUrl, cookies)
  }
}
